<template>

  <el-container>
    <el-header style="width: 1400px;max-width: 100%;margin: 0 auto">
      <img style="width: 100px;float: left;vertical-align: middle;margin-top: 18px" :src="$baseUrl+'img/paraverse-dev-logo.png'"/>
      <div class="fr" style="margin-top: 20px;margin-right:5px;cursor: pointer">
        <el-link href="https://www.pingxingyun.com/community/classify" target="_blank">
          云社区
        </el-link>
      </div>

    </el-header>
    <el-main class="pxy-main" style="background:url('https://home-oss.pingxingyun.com/homePage/developer/bg.jpg')">

      <template>
        <!--     <el-tabs v-model="loginType" class="login">
               <el-tab-pane label="密码登录" name="password">-->
        <el-row :gutter="10" class="main-mob main-pc">
          <!-- <el-col :xs="0" :sm="12" :md="12" :lg="12" :xl="12"> -->
            <!-- <div style="max-width: 80%;height: 300px;margin-top: 2%"></div> -->
            <!-- <img style="max-width: 80%;margin-top: 2%" src="https://home-oss.pingxingyun.com/homePage/dev_login1.png"/>
          </el-col> -->
          <!-- <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12"> -->
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
            <el-card class="box-card" style="max-width: 550px;margin: 0 auto">
              <!-- <p class="login_title  extra-large">开发者平台账号登录</p> -->
              <div class="tab-box">
                <span :class="loginType==='account'?'act-color':''" @click="loginTypeChange('account')">开发者平台账号登录</span>
                <span :class="loginType==='wechat'?'act-color':''" @click="loginTypeChange('wechat')">微信扫码登录</span>
              </div>
              <el-form v-show="loginType==='account'" :rules="rules" :model="loginForm" ref="loginForm" class="login-container" label-position="left"
                       label-width="0px" v-loading="loading">
                <el-divider class="divider"></el-divider>
                <el-form-item prop="accountId">
                  <el-input class="col-md-12" type="text" v-model="loginForm.accountId" auto-complete="off"
                            placeholder="账户名"></el-input>
                </el-form-item>
                <el-form-item prop="password">
                  <el-input class="col-md-12" type="password" v-model="loginForm.password" auto-complete="off"
                            placeholder="密码"></el-input>
                </el-form-item>
                <el-form-item prop="verifyCode">
                  <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" style="padding: 0 !important;">
                    <el-input type="text" v-model="loginForm.verifyCode" auto-complete="off" placeholder="验证码"></el-input>
                    <p style="position: absolute;right: 0;top: 23px;color: #666;">看不清？点击图片刷新</p>
                  </el-col>
                  <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="8" style="text-align:right;">
                    <a class="" href="javascript:void(0);"><img style="width: 115px;height: 40px" v-on:click="change()" ref="captcha"
                                                                class="captcha"/></a>
                  </el-col>
                </el-form-item>
                <el-form-item>
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" style="padding: 0 !important;">
                    <el-button type="primary" style="width: 100%" @click.native.prevent="submitClick">登录</el-button>
                  </el-col>
                </el-form-item>
                <el-form-item>
                  <div style="float: left">
                    <router-link :to="{ path: '/forgetPassword'}">&nbsp;&nbsp;忘记密码？</router-link>
                  </div>
                  <div style="float: right">还没有账号？
                    <el-button type="text" @click="tpRegister">立即注册</el-button>
                  </div>
                </el-form-item>
              </el-form>
              <div class="wx-box" v-show="loginType==='wechat'">
                <el-divider class="divider"></el-divider>
                <div :class="uuid?'wxcode-box':''">
                  <div id="wxcode" ref="wxcode" key="24"></div>
                </div>
                <p style="text-align: center;margin-top: 30px;">扫码进行「<strong>微信登录</strong>」</p>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </template>

    </el-main>
  </el-container>
</template>
<script>
  import comm from '@/utils/comm';
  import {Message} from "element-ui";
  import smsCode from '@/components/smsCodeComponent';
  import QRCode from 'qrcodejs2';

  export default {
    components: {smsCode},
    created: function () {

    },
    mounted: function () {
      this.change();
      comm.loadEnterFun(this.submitClick);
      document.getElementById('fullscreen-button').addEventListener('click', function() {
        var element = document.documentElement;
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          element.msRequestFullscreen();
        }
      });

    },
    data() {
      return {
        captchaUrl: '',
        loginType: 'account',
        rules: {
          accountId: [{required: true, message: '请输入账户名', trigger: 'blur'}],
          mobile: [{required: true, message: '请输入手机号', trigger: 'blur'}],
          smsCode: [{required: true, message: '请输入验证码', trigger: 'blur'}],
          password: [{required: true, message: '请输入密码', trigger: 'blur'}],
          verifyCode: [{required: true, message: '请输入验证码', trigger: 'blur'}]
        },
        checked: true,
        loginForm: {
          accountId: '',
          password: '',
          captchaId: '',
          verifyCode: '',
          smsCode: '',
        },
        loading: false,
        wxcode: null,
        uuid: null,
        wxlogintimer: null,
      }
    },
    methods: {
      loginTypeChange(type) {
        this.loginType = type;
        if(type==='wechat' && this.uuid === null) {
          this.getRequest('/wechat/qrcode-url').then(res => {
            console.log(res)
            if(res.data.code === 1000 && res.data.result) {
              this.centerDialogVisible = false;
              this.qrcodeDialogVisible = true;
              // this.qrcodeFn(res.data.result.qrUrl);
              if(this.$refs['wxcode'].innerHTML)this.$refs['wxcode'].innerHTML='';
              this.qrcode = new QRCode(this.$refs.wxcode, {
                text: res.data.result.qrUrl,
                width: 150,
                height: 150,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: 3
              })
             
              this.uuid = res.data.result.uuid;
              this.wxlogintimer = setInterval(() => {
                this.getWxLoginStatus();
              }, 3000)
            }
          })
        }else if(type==='wechat' && this.uuid){
          this.wxlogintimer = setInterval(() => {
            this.getWxLoginStatus();
          }, 3000)
        } else {
          this.change();
          if(this.wxlogintimer) clearInterval(this.wxlogintimer);
        }
      },
      // 获取wx登录状态
      async getWxLoginStatus() {
        var _this = this;
        await this.getRequest('/wechat/login-status', {uuid: this.uuid}).then(res => {
          if(res.data.code === 1000 && res.data.result.token) {
            const user = res.data.result;
            this.$store.commit('login', user);
            if(this.wxlogintimer) clearInterval(this.wxlogintimer);

             //检查是否包含targetUrl,若包含，则直接跳转到targetUrl中
            let theRequest =  _this.getRequestParam();
            if(theRequest['targetUrl'] != null){
              if(this.ismobile()) {
                let toUrl = 'https://m.pingxingyun.com'+theRequest['targetUrl']+'?token='+user.token+'&accountId='+user.accountId
                window.location.href = toUrl;
              } else {
                let toUrl = 'https://www.pingxingyun.com'+theRequest['targetUrl']+'?token='+user.token+'&loginId='+user.loginId;
                window.location.href = toUrl;
              }
            }else {
              const curr = localStorage.getItem('preRoute')
              if (curr != null) {
                this.$router.replace({ path: curr });
              } else if(user.role == '1' || user.role == '2'){
                this.$router.replace({path: '/console'});
              }else {
                this.$router.replace({path: '/audit/ec'});
              }

            }
          }
        })
      },
      // 是否是移动端
      ismobile() {
        let flage;
        let sUserAgent= navigator.userAgent.toLowerCase();
        let bIsIpad= sUserAgent.match(/ipad/i) == "ipad";
        let bIsIphoneOs= sUserAgent.match(/iphone os/i) == "iphone os";
        let bIsMidp= sUserAgent.match(/midp/i) == "midp";
        let bIsUc7= sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
        let bIsUc= sUserAgent.match(/ucweb/i) == "ucweb";
        let bIsAndroid= sUserAgent.match(/android/i) == "android";
        let bIsCE= sUserAgent.match(/windows ce/i) == "windows ce";
        let bIsWM= sUserAgent.match(/windows mobile/i) == "windows mobile";
        if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
          flage = true;
          return flage;
        } else {
          flage = false;
          return flage;
        }
      },
      change: function () {
        this.getRequest('/uacUser/captcha', {'d': new Date().getTime()}).then(resp => {
          this.$refs.captcha.src = resp.data.result;
          this.loginForm.captchaId = resp.headers.captchaid;
        })
      },
      submitClick: function () {
        var _this = this;
        const params = {
          ...this.loginForm
        };
        this.$refs["loginForm"].validate((valid) => {
          if (valid) {
            this.loading = true;
            this.postRequestJson('/uacUser/login', JSON.stringify(params), _this.loginForm.captchaId).then(resp => {
              _this.loading = false;
              if (resp && resp.status == 200) {
                var data = resp.data;
                if (data.code == 1000) {
                  if(window.localStorage.getItem('source')) window.localStorage.removeItem('source');//注册使用-临时存储的活动来源字段 登陆成功将就删除
                  var user = data.result;
                  _this.$store.commit('login', user);
                  //检查是否包含targetUrl,若包含，则直接跳转到targetUrl中
                 let theRequest =  _this.getRequestParam();
                  if(theRequest['targetUrl'] != null){
                    if(this.ismobile()) {
                      let toUrl = 'https://m.pingxingyun.com'+theRequest['targetUrl']+'?token='+user.token+'&accountId='+user.accountId
                      window.location.href = toUrl;
                    } else {
                      let toUrl = 'https://www.pingxingyun.com'+theRequest['targetUrl']+'?token='+user.token+'&loginId='+user.loginId;
                      window.location.href = toUrl;
                    }
                  }else {
                    const curr = localStorage.getItem('preRoute')
                    if (curr != null) {
                      this.$router.replace({ path: curr });
                    } else if(user.role == '1' || user.role == '2'){
                      this.$router.replace({path: '/console'});
                    }else {
                      this.$router.replace({path: '/audit/ec'});
                    }

                  }
                  /* this.$router.replace({path: '/sn/add'});*/
                } else {
                  Message.error(data.message);
                  _this.change();
                }

              }
            });
          }
        })
      },
       getRequestParam:function () {
         let url = location.href; //获取url中"?"符后的字串
         let theRequest = new Object();
         if (url.indexOf("?") != -1) {
           let str = url.substring(url.indexOf("?")+1,url.length);
           let strs = str.split("&");
           for (var i = 0; i < strs.length; i++) {
             theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
           }
         }
         return theRequest;
       },
      //  立即注册
       tpRegister() {
        if(window.localStorage.getItem('source')) {
          this.$router.push({
            path: '/register',
            query: {
              source: window.localStorage.getItem('source')
            }
          })
        } else {
          this.$router.push('/register');
        }
       }
    },
    destroyed() {
      document.onkeydown = undefined
    }
  }
</script>
<style lang="scss">
@media screen and (max-width: 768px) {
  .pxy-main.el-main {
    padding: 20px 16px!important;
  }
  .main-mob {
    margin: 0 auto;
  }
}
@media screen and (min-width: 769px) {
  .main-pc {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: calc(100% - 40px);
  }
}
.tab-box {
  max-width: 460px;
  width: 100%;
  margin: 0 auto;
  margin-top: 10px;
  font-size: 18px;
  span {
    cursor: pointer;
    display: inline-block;
    width: 50%;
    text-align: center;
  }
}
.act-color {
  color: #ff6a00;
}
.wx-box {
  margin-bottom: 20px;
  min-height: 330px;
}
.wxcode-box {
  width: 170px;
  border: 1px solid #999;
  border-radius:10px;
  padding: 10px;
  box-sizing: border-box;
  margin: 0 auto;
  text-align: center;
  margin-top: 70px;
}
</style>
